import _ from "lodash";
import Vue from 'vue'


const ErrorPortfolioStore = {
    namespaced: true,
    state: ()=>({
        errors: [],
    }),

    getters: {
        errors: state => state.errors,
    },

    mutations: {
        ADD_ERROR(state, error) {
            state.errors.push(error);
        },
        CLEAR_ERRORS(state, error) {
            const index = _.findIndex(state.errors, (i)=> !i.show)
            state.errors.splice(index, 1);
        },
    },

    actions: {
        addError ({ state, commit }, error) {
            error["key"] = state.errors.length;
            commit("ADD_ERROR", error);
        },

        clearErrors ({ commit }) {
            commit("CLEAR_ERRORS");
        },
    },
}

export default ErrorPortfolioStore